/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
/* eslint-disable */ 

(function ($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {

    // All pages
    'common': {
      init: function () {
        // ==========================================================================
        //  Redirect all users who haven't agreed to disclaimer
        // ==========================================================================
        function gatedCheck() {
          var isBlockerEnabled = document.body.dataset.blocker === 'enabled';

          if (isBlockerEnabled) {
            var possibleClasses = ['page-template-template-investor-centre', 'pagename-home', 'blog'];

            if (possibleClasses.some(function (className) {
              return document.body.classList.contains(className);
            })) {
              if (localStorage.getItem('gateAgree') === 'declined') {
                window.location = '/gated-content-restricted/';
              } else if(localStorage.getItem('gateAgree') === 'accept') {
                // Remove the gated blocker if disclaimer has been accepted
                if(localStorage.getItem('gateAgree') === 'accept') {
                  var hiddenContent = document.querySelector('.main-wrapper.gated-hidden');
                  
                  if (hiddenContent) {
                    hiddenContent.classList.remove('gated-hidden');
                  }
                }
              } else {
                localStorage.setItem('gatedContentReturnURL', window.location.href);
                window.location = '/gated-content-disclaimer/';
              }
            }
          }
        }
        
        gatedCheck();

        // ==========================================================================
        //  Check for country when proceeding
        // ==========================================================================
        function gatedDisclaimer() {
          var proceedButton = document.querySelector('.gate-disclaimer button');
          var countryOfResidenceSelect = document.querySelector('.country-of-residence select');
          var countryAccessingSelect = document.querySelector('.accessing-country select');

          if (proceedButton) {
            var disallowedCoutries = ['none', 'United States of America', 'Guam', 'Northern Mariana Islands', 'Puerto Rico', 'Virgin Islands (USA)', 'Australia', 'Canada', 'Japan', 'South Africa', 'New Zealand'];

            proceedButton.addEventListener("click", function() {
              
              if (countryOfResidenceSelect.value === 'none' || countryAccessingSelect === 'none') {
                alert('Please select a country');
              }
              
              if (disallowedCoutries.includes(countryOfResidenceSelect.value) || disallowedCoutries.includes(countryAccessingSelect.value)) {
                localStorage.setItem('gateAgree', 'declined');
                window.location = '/gated-content-restricted/';
              } else {
                window.location = '/gated-content-notice/';
              }
            });
          }
        }

        gatedDisclaimer();

        // ==========================================================================
        //  Watch for agree/disagree on gated notice
        // ==========================================================================
        function gatedNotice() {
          if (document.body.classList.contains('page-template-gated-notice')) {

            // If a user has already declined, don't let them revisit this page
            if (localStorage.getItem('gateAgree') === 'declined') {
              window.location = '/';
            } else {
              var doNotAgreeCheckBox = document.querySelector('.container-checkbox.do-not-agree');
              var agreeCheckBox = document.querySelector('.container-checkbox.agree');

              if (doNotAgreeCheckBox) {
                doNotAgreeCheckBox.addEventListener("click", function(event) {
                  localStorage.setItem('gateAgree', 'declined');
                  window.location = '/gated-content-restricted/';
                });
              }

              if (agreeCheckBox) {
                agreeCheckBox.addEventListener("click", function(event) {
                  localStorage.setItem('gateAgree', 'accept');

                  if (localStorage.getItem('gatedContentReturnURL') !== null) {
                    window.location = localStorage.getItem('gatedContentReturnURL');
                  } else {
                    window.location = '/';
                  }
                });
              }
            }
          }
        }

        gatedNotice();



        $(function() {
          $('a[href*="#"]:not([href="#"])').click(function() {
          if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
            if (target.length) {
              $('html, body').animate({
                scrollTop: target.offset().top - 156
              }, 500);
            return false;
            }
          }
          });
        });
        
        $('#burger').click(function(){
          $(this).toggleClass('open');
          $(this).addClass('close');
          $('html').toggleClass('menu-open');
        });
        
        $('li.menu-item-has-children').click(function(){
          $(this).toggleClass('open');
        });
        
        $('ul.tabs li, .tab-accordion-heading').click(function() {
          $('.tab-content, ul.tabs li, .tab-accordion-heading').removeClass('active');
        
          var activeTab = $(this).attr("rel");
          $("#"+activeTab).addClass('active');
          $(this).addClass("active");
          $(".tab-accordion-heading[rel^='"+activeTab+"'], ul.tabs li[rel^='"+activeTab+"']").addClass("active");
        });
        
        $('.gfield .large, .gfield .gfield_checkbox, .ginput_container_radio').parents('.gfield').addClass('large');
        $('.gfield .small').parents('.gfield').addClass('small');
        $('.gsection').each(function(){
          $(this).nextUntil('.gsection').wrapAll('<span class="columns clearfix"></span>');
        });
        $('.gform_wrapper.gform_wrapper form .columns').parents('form').addClass('has-columns');
        $('.ginput_container_radio, .ginput_container_checkbox').parent('.gfield').addClass('radio-checkbox');
        
        $(document).bind('gform_post_render', function(){
          $('.gfield .large, .gfield .gfield_checkbox, .ginput_container_radio').parents('.gfield').addClass('large');
          $('.gfield .small').parents('.gfield').addClass('small');
          $('.gsection').each(function(){
            $(this).nextUntil('.gsection').wrapAll('<span class="columns clearfix"></span>');
          });
          $('.gform_wrapper.gform_wrapper form .columns').parents('form').addClass('has-columns');
          $('.ginput_container_radio, .ginput_container_checkbox').parent('.gfield').addClass('radio-checkbox');
        
          $('.matchHeight').matchHeight(true);
        });
        
        $('p:has(img)').css('margin-bottom','0');
        
        $('.t-item .read-more').click(function(){
          $(this).parents('.t-item').toggleClass('open');
        });
        
        $('.onchange').on('change', function() {
          var _ = $(this);
        
          if (_.val() !== '#') {
            window.location.href = _.val();
          }
        });
        
        
        var wow = new WOW({
          boxClass: 'wow',
          animateClass: 'animated',
          offset: 156,
          mobile: true,
          live: true,
          callback: function(box) {
        
          },
          scrollContainer: null
        });
        
        wow.init();
        
        setTimeout(function(){
          $('.slick').addClass('loaded');
          $(window).trigger('resize');
          $('.matchHeight').matchHeight(true);
        
          setTimeout(function(){
            $('.slick').addClass('no-overflow');
            $(window).trigger('resize');
            $('.matchHeight').matchHeight(true);
          }, 600);
        }, 20);
        
        $( window ).resize(function() {
        
          setTimeout(function(){
            $('.matchHeight').matchHeight(true);
          }, 800);
        });
        
        $('.video-slide').slick({
          dots: true,
          arrows: true,
          infinite: true,
          speed: 200,
        });
        
        $('.fancybox').fancybox();
        
        $(".video-banner").fitVids();
        
        $('.matchHeight').matchHeight(true);  
        
        /* jshint ignore:start */
        
        (function($) {
        
        /*
        *  new_map
        *
        *  This function will render a Google Map onto the selected jQuery element
        *
        *  @type	function
        *  @date	8/11/2013
        *  @since	4.3.0
        *
        *  @param	$el (jQuery element)
        *  @return	n/a
        */
        
        function new_map( $el ) {
        
          // var
          var $markers = $el.find('.marker');
        
        //	// var
        //	var styleArray = [
        //		{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}
        //	];
        
          // vars
          var args = {
            zoom		: 16,
            //styles: styleArray,
            draggable: false,
            scrollwheel: false,
            center		: new google.maps.LatLng(0, 0),
            mapTypeId	: google.maps.MapTypeId.ROADMAP
          };
        
          // create map
          var map = new google.maps.Map( $el[0], args);
        
        
          // add a markers reference
          map.markers = [];
        
        
          // add markers
          $markers.each(function(){
        
            add_marker( $(this), map );
        
          });
        
        
          // center map
          center_map( map );
        
        
          // return
          return map;
        
        }
        
        /*
        *  add_marker
        *
        *  This function will add a marker to the selected Google Map
        *
        *  @type	function
        *  @date	8/11/2013
        *  @since	4.3.0
        *
        *  @param	$marker (jQuery element)
        *  @param	map (Google Map object)
        *  @return	n/a
        */
        
        function add_marker( $marker, map ) {
        
          // var
          var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );
        
        //	var customPin = {
        //		url: '../wp-content/themes/pukka/assets/images/map-pin.png',
        //		size: new google.maps.Size(200, 145),
        //		scaledSize: new google.maps.Size(200, 145),
        //		origin: new google.maps.Point(0, 0),
        //		anchor: new google.maps.Point(100, 145)
        //	};
        
          // create marker
          var marker = new google.maps.Marker({
            position	: latlng,
            map			: map,
            //icon: customPin
          });
        
          // add to array
          map.markers.push( marker );
        
          // if marker contains HTML, add it to an infoWindow
          if( $marker.html() )
          {
            // create info window
            var infowindow = new google.maps.InfoWindow({
              content		: $marker.html()
            });
        
            // show info window when marker is clicked
            google.maps.event.addListener(marker, 'click', function() {
        
              infowindow.open( map, marker );
        
            });
          }
        
        }
        
        /*
        *  center_map
        *
        *  This function will center the map, showing all markers attached to this map
        *
        *  @type	function
        *  @date	8/11/2013
        *  @since	4.3.0
        *
        *  @param	map (Google Map object)
        *  @return	n/a
        */
        
        function center_map( map ) {
        
          // vars
          var bounds = new google.maps.LatLngBounds();
        
          // loop through all markers and create bounds
          $.each( map.markers, function( i, marker ){
        
            var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
        
            bounds.extend( latlng );
        
          });
        
          // only 1 marker?
          if( map.markers.length === 1 )
          {
            // set center of map
            map.setCenter( bounds.getCenter() );
            map.setZoom( 16 );
          }
          else
          {
            // fit to bounds
            map.fitBounds( bounds );
          }
        
        }
        
        /*
        *  document ready
        *
        *  This function will render each map when the document is ready (page has loaded)
        *
        *  @type	function
        *  @date	8/11/2013
        *  @since	5.0.0
        *
        *  @param	n/a
        *  @return	n/a
        */
        // global var
        var map = null;
        
        $(document).ready(function(){
        
          $('.acf-map').each(function(){
        
            // create map
            map = new_map( $(this) );
        
          });
        
        });
        
        })(jQuery);

        /* jshint ignore:end */
        

      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },

    // Home page
    'investor_centre': {
      init: function () {
        
        // tabbed content
          $(".tab_content").hide();
          $(".tab_content:first").show();
          $(".tabs li:first").addClass('active');

        /* if in tab mode */
          $("ul.tabs li").click(function() {
          
            $(".tab_content").hide();
            var activeTab = $(this).attr("rel"); 
            $("#"+activeTab).fadeIn();		
          
            $("ul.tabs li").removeClass("active");
            $(this).addClass("active");

          $(".tab_drawer_heading").removeClass("d_active");
          $(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");
          
          });
        /* if in drawer mode */
        $(".tab_drawer_heading").click(function() {
            
            $(".tab_content").hide();
            var d_activeTab = $(this).attr("rel"); 
            $("#"+d_activeTab).fadeIn();
          
          $(".tab_drawer_heading").removeClass("d_active");
            $(this).addClass("d_active");
          
          $("ul.tabs li").removeClass("active");
          $("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
          });
        
        
        /* Extra class "tab_last" 
          to add border to right side
          of last tab */
        $('ul.tabs li').last().addClass("tab_last");


        /* Open video lightbox on click of button */
        $('.media-card__watch-link').click(function() {
          var videoNumber = $(this).attr("data-video");
        });
        

      },
      finalize: function () {
        // JavaScript to be fired after the init JS
      }
    },


    // FAQs
    'page_template_template_faqs': {
      init: function () {
        var faqs = Array.from(Array.from(document.querySelectorAll('.single-faq')));

        if (faqs) {
          faqs.forEach(function (faq) {
            faq.addEventListener("click", function () {
              faqs.forEach(function (faq) {
                faq.classList.remove('active');
              });

              if (faq.classList.contains('active')) {
                faq.classList.remove('active');
              } else {
                faq.classList.add('active');
              }
            });
          });
        }

      },
      finalize: function () {
        // JavaScript to be fired after the init JS
      }
    },

    // Shareholder info 
    'financial_information': {
      init: function () {
        var tabs = Array.from(Array.from(document.querySelectorAll('.tab-nav li')));

        if (tabs) {
          tabs.forEach(function (tab) {
            tab.addEventListener("click", function () {
              if (!tab.classList.contains('active')) {
                $('.tab-nav li').removeClass('active');
                $('.overview-documents .documents').removeClass('active');
                tab.classList.add('active');
                var currentTab = tab.dataset.cat;
                var currentContent = document.querySelector(".overview-documents .documents[data-cat=\"".concat(tab.dataset.cat, "\"]"));
                currentContent.classList.add('active');
              }
            });
          });
        }

      },
      finalize: function () {
        // JavaScript to be fired after the init JS
      }
    },

  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.

/* eslint-enable */
